import { GtagEvent } from '../types';
import gtag from './gtag'

/**
 * Send one or more analytics events in parallel and wait for all of them to complete.
 *
 * This wraps around the gtag 'event' command using callbacks to prevent promise
 * resolution until the command either times out or returns successfully.
 *
 * In the event that gtag callbacks aren't working, a secondary timeout is
 * also implemented using `window.setTimeout()`. Either way, the callback
 * registered to an event will only be fired once.
 *
 * Individual event callbacks and timeouts will be honored where specified.
 */
const sendAnalyticsEvents = (...events: GtagEvent[]): Promise<void> => (
    Promise.all(events.map(({event_name, event_params}) =>
        new Promise<void>((resolve) => {
            const event_timeout = event_params.event_timeout ?? 2000;
            const event_callback = () => {
                if (timeout === null) {
                    return;
                }
                timeout = null;
                if (event_params.event_callback) {
                    event_params.event_callback();
                }
                resolve();
            };
            let timeout = window.setTimeout(event_callback, event_timeout);
            gtag('event', event_name, { ...event_params, event_callback });
        })
    )) as unknown as Promise<void>
)

export default sendAnalyticsEvents
